import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import Chart from "Components/Common/Chart";
import { chartColors } from "common/constant";

const TariffWiseConsumersPieChart = ({ changeTariffType, data, labels, t }) => {
  const options = {
    chart: {
      width: 300,
      type: "donut",
      events: {
        click: (_, __, config) => {
          const id = config?.globals?.selectedDataPoints?.[0]?.[0];
          handleChangeCategoryType(id, config);
        },
        legendClick: (_, id, config) => {
          changeTariffType((prev) => ({
            title: options?.labels?.[id] ?? prev.title,
            color: config?.globals?.colors?.[id] ?? prev.color,
          }));
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              showAlways: true,
              show: true,
            },
          },
        },
      },
    },
    fill: {
      type: "gradient",
    },
    labels: labels,
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => [
        seriesName,
        " - ",
        opts.w.globals.series[opts.seriesIndex],
      ],
    },
    colors: chartColors,
  };

  const handleChangeCategoryType = (id, config) => {
    changeTariffType((prev) => ({
      title: config?.config?.labels?.[id] ?? prev.title,
      color: config?.globals?.colors?.[id] ?? prev.color,
    }));
  };

  return (
    <Chart
      title={t("Tariff wise number of consumers")}
      options={options}
      series={data}
      type="donut"
      height={500}
    />
  );
};

TariffWiseConsumersPieChart.propTypes = {
  changeTariffType: PropTypes.func,
  data: PropTypes.array,
  labels: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(TariffWiseConsumersPieChart);
